import React from "react";
import {
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withProps,
  setDisplayName
} from "recompose";
import { connect } from "react-redux";
import { actions } from "../../modules/contracts";
import { actions as itemActions } from "../../modules/items";
import { actions as noteActions } from "../../modules/notes";
import { actions as customerActions } from "../../modules/customers";
import { actions as scooterActions } from "../../modules/scooters";
import { actions as discountActions } from "../../modules/discounts";
import TryAgain from "../../components/TryAgain";
import Loading from "../../components/Loading";

const mapStateToProps = state => ({
  currentContract: state.contracts.currentContract,
  fetchingContract: state.contracts.fetchingContract,
  failFetchContract: state.contracts.failFetchContract,
  successFetchContract: state.contracts.successFetchContract,
  currentDealer: state.dealers.currentDealer,
  role: state.settings.role,
  user: state.auth.user
});
const mapDispatchToProps = {
  fetchContract: actions.fetchContract,
  fetchContractSeamless: actions.fetchContractSeamless,
  setItems: itemActions.setItems,
  setCurrentItem: itemActions.setCurrentItem,
  setNotes: noteActions.setNotes,
  setCurrentNote: noteActions.setCurrentNote,
  setCurrentCustomer: customerActions.setCurrentCustomer,
  setCurrentScooter: scooterActions.setCurrentScooter,
  setDiscounts: discountActions.setDiscounts,
  setCurrentDiscount: discountActions.setCurrentDiscount,
  resetState: actions.resetState
};

export const withState = connect(
  mapStateToProps,
  mapDispatchToProps
);

const failed = ({ failFetchContract }) => failFetchContract;
const isFetching = ({ fetchingContract }) => fetchingContract;
const hasNoContract = ({ currentContract }) => !currentContract;
const isInitial = ({
  failFetchContract,
  fetchingContract,
  successFetchContract,
  currentContract
}) =>
  !failFetchContract &&
  !fetchingContract &&
  !successFetchContract &&
  !currentContract;

const fetchContractCallback = (
  {
    match: {
      params: { contract_id }
    },
    history: { replace },
    currentDealer,
    fetchContract,
    fetchContractSeamless,
    setCurrentCustomer,
    setCurrentScooter,
    setItems,
    setNotes,
    role,
    user,
    setDiscounts
  },
  type
) => () => {
  const onSuccessContract = contract => {
    if (contract) {
      setCurrentCustomer(contract.customer || {});
      setCurrentScooter(contract.scooter || {});
      setItems(contract.items || []);
      setNotes(contract.notes || []);
      setDiscounts(contract.discounts || []);
    } else {
      replace("/contracts");
    }
  };
  if (user) {
    if (role === "staff") {
      const getContract =
        type === "normal" ? fetchContract : fetchContractSeamless;
      getContract({ dealer_id: currentDealer.id, contract_id }).then(
        onSuccessContract
      );
    } else {
      let contracts = role === "contact" ? user.contact_for : user.contracts
      let contract = contracts.find(
        ({ tracking_number }) => tracking_number === contract_id
      );
      contract &&
        fetchContract({ dealer_id: contract.dealer.id, contract_id }).then(
          onSuccessContract
        );
    }
  }
};

export const withFetchContractActions = withProps(props => ({
  fetchContract: fetchContractCallback(props, "normal"),
  fetchContractSeamless: fetchContractCallback(props, "seamless"),
  resetState() {
    const {
      resetState,
      setCurrentCustomer,
      setCurrentScooter,
      setItems,
      setCurrentItem,
      setNotes,
      setCurrentNote,
      setDiscounts,
      setCurrentDiscount
    } = props;
    resetState();
    setCurrentCustomer(null);
    setCurrentScooter(null);
    setItems([]);
    setCurrentItem(null);
    setNotes([]);
    setCurrentNote(null);
    setDiscounts([]);
    setCurrentDiscount(null);
  }
}));

const TryAgainContract = ({ failFetchContract, fetchContract, ...props }) => (
  <TryAgain label={failFetchContract} onTryAgain={fetchContract} />
);

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

export const withFetchStates = nonOptimalStates([
  {
    when: isFetching,
    render: renderComponent(withProps({ label: "Loading Contract" })(Loading))
  },
  { when: failed, render: renderComponent(TryAgainContract) },
  { when: hasNoContract, render: renderNothing },
  { when: isInitial, render: renderNothing }
]);

export const withFetchContractHooks = lifecycle({
  componentDidMount() {
    this.props.fetchContract();
  },
  componentWillUnmount() {
    this.props.resetState();
  }
});

export default compose(
  setDisplayName("WithFetchContract"),
  withState,
  withFetchContractActions,
  withFetchContractHooks,
  withFetchStates
);
